import { useCallback } from 'react';
import { useNavigation } from '@react-navigation/native';

import { DashboardOverviewScreenName } from '@v2/pages/dashboard/navigation/config';
import { useDashboardScreenTopOffset } from '@v2/pages/dashboard/common/hooks/useDashboardScreenTopOffset';
import { DASHBOARD_DRILLDOWN_WRAPPER_HEADER_MARGIN_TOP } from '@v2/pages/dashboard/modules/drilldown/components/DashboardDrilldownWrapper/constants';

export const useManageDashboardDrilldownWrapper = () => {
  const navigation = useNavigation<any>();

  const onBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      navigation.navigate(DashboardOverviewScreenName as never);
    }
  }, [navigation]);

  const topOffset = useDashboardScreenTopOffset(DASHBOARD_DRILLDOWN_WRAPPER_HEADER_MARGIN_TOP);

  return { onBack, topOffset };
};
